import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { DashboardLink } from "./dashboard-link";

interface DashboardSectionHeaderProps {
  title: string;
  caption?: string;
  link?: { to: string; label: string };
}

/** A section title above a card, with an optional "see more" link. */
export const DashboardSectionHeader = ({
  title,
  caption,
  link,
}: DashboardSectionHeaderProps) => (
  <Stack
    direction="row"
    align="baseline"
    justify="between"
    gap={2}
    className="w-full flex-wrap"
  >
    <Stack direction="row" align="baseline" gap={2} className="flex-wrap">
      <Text variant="title">{title}</Text>
      {caption && <Text tone="muted">{caption}</Text>}
    </Stack>
    {link && <DashboardLink {...link} />}
  </Stack>
);
